import { useContext } from 'react';
import { FiltersContext, FiltersContextUpdate } from '../Context/FiltersContext';

const useFilterHandlers = () => {
  const { handleFilters } = useContext(FiltersContextUpdate);
  const {filters} = useContext(FiltersContext)

  const handleFilter = (filterId: any, value: any) => {
    if(filterId !== 'page' && value){
      handleFilters('page', '');
    }
    handleFilters(filterId, value);
  };

  const handleFilterArray = (filterId: string, e: any) => {
    let values: any[]=[];
    if(filterId !== 'page' && e.length !== 0){
      handleFilters('page', '');
    }
    if (e) {
      e.map((item: any) => {
        if(item !== undefined){
          values.push(item.value ? item.value : item)
        }
      });
      handleFilters(filterId, values);
    } else {
      handleFilters(filterId, '');
    }
  }

  const getFilterValue = (field: string) => {
    return filters.find((element) => {
      if (element.id === field) {
        return element
      }
    })
  }

  return { handleFilter, handleFilterArray, getFilterValue };
};

export default useFilterHandlers;
